// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.notifications.RentalManagerUserNotificationsWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type {
  RentalManagerNotificationDeviceType,
  UserNotificationsAllNotificationsResponseWebDto,
  UserNotificationsDeleteWebDto,
  UserNotificationsMarkAsReadWebDto,
} from '../..';

interface AllNotificationsParams {
  includeHasNewNotificationsForNotificationCenter?: boolean;
  limit?: number;
  start?: number;
}
interface DeleteParams {
  notificationId: number;
}
interface MarkAsReadParams {
  notificationId: number;
}
interface TrackingParams {
  deviceType: RentalManagerNotificationDeviceType;
  event: string;
  pushNotificationId: string;
  rentalManagerNotificationId: number;
}

export const RentalManagerUserNotificationsWebApiHandler_allNotifications_Path =
  '/api/web/v1/users/notifications/allNotifications';

/**
 * Get all notifications of a user
 */
export const RentalManagerUserNotificationsWebApiHandler_allNotifications = (
  getParams: AllNotificationsParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<AllNotificationsParams, never, UserNotificationsAllNotificationsResponseWebDto>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserNotificationsWebApiHandler_allNotifications_Path,
      method: 'GET',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserNotificationsWebApiHandler_delete_Path = '/api/web/v1/users/notifications/delete';

/**
 * Delete a notification
 */
export const RentalManagerUserNotificationsWebApiHandler_delete = (getParams: DeleteParams, client = getClient()) => {
  return httpFrontEndRequest<DeleteParams, never, UserNotificationsDeleteWebDto>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserNotificationsWebApiHandler_delete_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserNotificationsWebApiHandler_markAllAsRead_Path =
  '/api/web/v1/users/notifications/markAllAsRead';

/**
 * Mark all notifications as read
 */
export const RentalManagerUserNotificationsWebApiHandler_markAllAsRead = (client = getClient()) => {
  return httpFrontEndRequest<never, never, void>(
    {
      endpoint: RentalManagerUserNotificationsWebApiHandler_markAllAsRead_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserNotificationsWebApiHandler_markAsRead_Path = '/api/web/v1/users/notifications/markAsRead';

/**
 * Mark a notification as read
 */
export const RentalManagerUserNotificationsWebApiHandler_markAsRead = (
  getParams: MarkAsReadParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<MarkAsReadParams, never, UserNotificationsMarkAsReadWebDto>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserNotificationsWebApiHandler_markAsRead_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserNotificationsWebApiHandler_tracking_Path = '/api/web/v1/users/notifications/tracking';

/**
 * Track push notifications events
 */
export const RentalManagerUserNotificationsWebApiHandler_tracking = (
  getParams: TrackingParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<TrackingParams, never, void>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserNotificationsWebApiHandler_tracking_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};
